export default class ClientDeviceType {
//  static get Unknown () { return 'unknown';
  static get Web () { return 'web' }
  static get Mobile () { return 'mobile' }
  static get Crm () { return 'crm' }

  static getName (enumValue) {
    switch (enumValue) {
      case ClientDeviceType.Web:
        return 'Сайт'

      case ClientDeviceType.Crm:
        return 'CRM'

      case ClientDeviceType.Mobile:
        return 'Мобильное приложение'

      default:
        return enumValue
    }
  }

  static getAllVariants () {
    const variants = [
      ClientDeviceType.Web,
      ClientDeviceType.Mobile,
      ClientDeviceType.Crm,
    ]

    return variants.map(item => ({
      value: item,
      name: ClientDeviceType.getName(item),
    }))
  }
}
